import React, { PropsWithChildren, useCallback, useContext, useRef } from 'react';

import { CustomBottomSheetModalProvider } from '@/feature/alerts/components/CustomBottomSheetModalProvider';

import { PicksRemovedModal, PicksRemovedModalRef } from './PicksRemovedModal';

type PicksRemovedModalContextType = {
    showPicksRemovedModal: (onDismiss?: () => void) => void;
    dismissPicksRemovedModal: () => void;
};

const PicksRemovedModalContext = React.createContext<PicksRemovedModalContextType | null>(null);

export const PicksRemovedModalProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const modalRef = useRef<PicksRemovedModalRef>(null);

    const showPicksRemovedModal = useCallback((onDismiss?: () => void) => {
        modalRef.current?.show(onDismiss);
    }, []);

    const dismissPicksRemovedModal = useCallback(() => {
        modalRef.current?.dismiss();
    }, []);

    return (
        <CustomBottomSheetModalProvider>
            <PicksRemovedModalContext.Provider value={{ showPicksRemovedModal, dismissPicksRemovedModal }}>
                {children}
                <PicksRemovedModal ref={modalRef} />
            </PicksRemovedModalContext.Provider>
        </CustomBottomSheetModalProvider>
    );
};

export const usePicksRemovedModal = () => {
    const context = useContext(PicksRemovedModalContext);
    if (!context) {
        throw new Error('usePicksRemovedModal must be used within a PicksRemovedModalProvider');
    }
    return context;
};
